import { isNil, TimedMap } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
import { InvalidKeyError } from '#common/types';
const getGlobalMetaValue = (layoutKvs) => {
    return layoutKvs.at(-1).value;
};
const DEFAULT_FILE_NODE_TTL = 15000; // 15 seconds
const CACHE_CHECK_INTERVAL = 1000;
export const createFileNodeManager = (kvHelpersWasm, metaStoreWasm, metadataCacheTtl) => {
    return new FileNodeManagerImpl(kvHelpersWasm, metaStoreWasm, metadataCacheTtl);
};
class FileNodeManagerImpl {
    kvHelpersWasm;
    metaStoreWasm;
    cache;
    logger = Logging.getLogger('FileNodeManager');
    constructor(kvHelpersWasm, metaStoreWasm, metadataCacheTtl) {
        this.kvHelpersWasm = kvHelpersWasm;
        this.metaStoreWasm = metaStoreWasm;
        this.cache = new TimedMap({
            timeoutMs: metadataCacheTtl ?? DEFAULT_FILE_NODE_TTL,
            timeoutCheckIntervalMs: CACHE_CHECK_INTERVAL,
        });
    }
    async getGlobalMetaValue(inodeId) {
        const entry = await this.getEntry(inodeId);
        return getGlobalMetaValue(entry.layoutKvs);
    }
    invalidateCache(inodeId) {
        this.cache.delete(inodeId);
    }
    async getSize(inodeId) {
        const entry = await this.getEntry(inodeId);
        return entry.metadata.size;
    }
    async getMetadata(inodeId) {
        const entry = await this.getEntry(inodeId);
        return entry.metadata;
    }
    async getLayoutKeyRange(inodeId) {
        const entry = await this.getEntry(inodeId);
        return entry.layoutKvs;
    }
    stop() {
        this.cache.stopTimeoutCheck();
    }
    async getEntry(inodeId) {
        let entry = this.cache.get(inodeId);
        if (!isNil(entry)) {
            return entry;
        }
        const layoutKvs = Array.from(await this.fetchLayoutKvs(inodeId));
        const metadata = this.kvHelpersWasm.parseMetadata(getGlobalMetaValue(layoutKvs));
        entry = {
            layoutKvs,
            metadata,
        };
        this.cache.set(inodeId, entry);
        return entry;
    }
    async fetchLayoutKvs(inodeId) {
        this.logger.trace('Fetching layout keys ...');
        const range = this.kvHelpersWasm.makeLayoutKeyRange(inodeId);
        const layoutKvs = Array.from(await this.metaStoreWasm.getIterator(range));
        if (layoutKvs.length === 0) {
            throw new InvalidKeyError('File metadata not found');
        }
        this.logger.trace('Global metadata key fetched.');
        return layoutKvs;
    }
}
